import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export default function SessionExpiredPopup({ open, onLoginAgain }) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === 'backdropClick') {
          return;
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 400,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
        },
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 20,
      }}
    >
      <DialogTitle
        sx={{
          color: 'grey.800',
          fontWeight: 600,
          pb: 1,
        }}
      >
        Session Expired
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <DialogContentText sx={{ color: 'grey.600' }}>
          Your session has expired. Please log in again.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          variant="contained"
          onClick={onLoginAgain}
          sx={{
            backgroundColor: '#ff6600',
            color: 'white',
            borderRadius: 1,
            px: 2.5,
            '&:hover': {
              backgroundColor: '#e55c00',
            },
          }}
        >
          LOGIN AGAIN
        </Button>
      </DialogActions>
    </Dialog>
  );
}
